import Panels from './Panels';
import './Panels.scss';
export default Panels;
